import INumerologyType from "@/interfaces/astrology/numerology/INumerologyType";
import arrayToObject from "@/libs/arrayToObject";
import {removeSymbol} from "@/libs/backend/apimapper";
import cloneObject from "@/libs/cloneObject";

import TranslationForm from "@/components/Includes/TranslationForm/TranslationForm.vue";
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
    name: 'NumerologyTypeForm',
    components: {
        TranslationForm
    }
})
export default class NumerologyTypeForm extends Vue {
    @Prop(Object) private formData!: INumerologyType;
    @Prop(Boolean) private loading!: boolean;

    private activeTabIndex: number = 0;

    private translations: any = [];

    private newTranslationConstructor: { locale: string, title: string, description: string } = {
        locale: '',
        title: '',
        description: ''
    };

    private isCannotEdit(field: string): boolean {
        return field === 'createdAt' || field === 'updatedAt' || field === 'id';
    }

    // Begin Handler by Form
    private invalidValue(fieldName: string) {
        return this.$validator.errors.has(fieldName);
    }

    private transformData() {
        const readyData = cloneObject(this.formData);
        this.translations.forEach((translation: any) => translation.locale = translation.locale.toLowerCase());
        readyData.translations = arrayToObject(this.translations, 'locale');
        return readyData;
    }

    private validateForm() {
        this.$validator.validateAll().then((result) => {
            if (result) {
                this.$emit('saveForm', this.transformData());
            }
        });
    }

    private handleSave() {
        (this.$refs.TranslationForm as HTMLFormElement).validateTranslations();
    }

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    private hideFields(field: string): boolean {
        return field === 'id' || field === 'translations';
    }
    // End Handler by Form

    @Watch('formData')
    private getTranslationsData() {
        if (this.formData) {
            const sourceData = Object.values(this.formData.translations);
            sourceData.filter((attr: any) => removeSymbol(attr));
            this.translations = sourceData;
        }
    }

    @Watch('formData')
    private defaultTab() {
        this.activeTabIndex = 0;
    }
}
